// extracted by mini-css-extract-plugin
module.exports = {"videoSkeleton":"VideoSkeleton_videoSkeleton__1fKFa","icon":"VideoSkeleton_icon__2ILIk"};